import SignUp from './SignUpContainer'

export default SignUp
